import { Mapper } from 'src/app/core/base/mapper';
import { WebInvitationModel } from '../models/web-invitation.model';
import { InvitationModel } from 'src/app/core/models/invitation.model';


export class WebInvitationMapper extends Mapper<WebInvitationModel, InvitationModel>{
    mapFrom(param: WebInvitationModel): InvitationModel {
        let invitation: InvitationModel = {
            groupId: param.group,
            roleId: param.roleId,
            email: param.email
        }
        return invitation;
    }

    mapTo(param: InvitationModel): WebInvitationModel {
        let webInvitation: WebInvitationModel = {
            group: param.groupId,
            roleId: param.roleId,
            email: param.email
        }
        return webInvitation;
    }
}
